import axios from 'axios'
import { trackPromise } from 'react-promise-tracker'
import { getProductsList } from '../products/ProductsFunctions'

/** Done */
export const getWarehouses = async (app) => {
  let warehouses = null 

  app.startLoadingIndicator()
  await trackPromise (
    axios.get(app.API_URI + '/warehouses')
    .then(result => {
        warehouses = result.data
        app.stopLoadingIndicator()
    })
    .catch(error => { app.errorLoadingIndicator(error) })
  )
  return warehouses
}

/** Done */
export const getProductsClassifications = async (app, lic=null) => {
  let products_classifications = null

  app.startLoadingIndicator("Getting products classifications")
  await trackPromise (
    axios.get(process.env.REACT_APP_API_URI + '/products/distinct/classification')
    .then(async (result) => {
      products_classifications = result.data
      app.stopLoadingIndicator()
    })
    .catch(error => { app.errorLoadingIndicator(error) })
  )
  return products_classifications 
}

/** Done */
export const getProductsSoldReport = async (app, date, silent=false) => {
  let products_sold = null

  if (!silent) app.startLoadingIndicator("Getting sales report")
  await trackPromise (
    axios.get(process.env.REACT_APP_API_URI + `/reports/productssold?df=${date.from}&dt=${date.to}`)
      .then(async (result) => {
        products_sold = result.data
        if (!silent) app.stopLoadingIndicator()
      })
      .catch(error => { app.errorLoadingIndicator(error) })
  )
  return products_sold
}

export const getUnmovingProductsReport = async (app, date) => {
  let unmoving_products = null
  app.startLoadingIndicator("Getting products report")
  await trackPromise (
    axios.get(process.env.REACT_APP_API_URI + `/reports/unmovingproducts?df=${date.from}&dt=${date.to}`)
    .then(async (result) => {
      unmoving_products = result.data
      app.stopLoadingIndicator()
    })
    .catch(error => { app.errorLoadingIndicator(error) })
  )
  return unmoving_products
}

export const getLogs = async (app, number_of_logs) => {
  let logs = null

  app.startLoadingIndicator("Getting logs report")
  await trackPromise (
    axios.get(process.env.REACT_APP_API_URI + `/logs?number_of_logs=${number_of_logs}`)
    .then(async (result) => {
      logs = result.data
      app.stopLoadingIndicator()
    })
    .catch(error => { app.errorLoadingIndicator(error) })
  )
  return logs 
}

export const getDailySalesReport = async (app, year, month) => {
  let daily_sales = null

  app.startLoadingIndicator("Getting Sales report")
  await trackPromise (
    axios.get(process.env.REACT_APP_API_URI + `/reports/dailysales?year=${year}&month=${month}`)
    .then(async (result) => {
      daily_sales = result.data
      app.stopLoadingIndicator()
    })
    .catch(error => { app.errorLoadingIndicator(error) })
  )
  return daily_sales
}

export const getMonthlySalesReport = async (app, year) => {
  let monthly_sales = null

  app.startLoadingIndicator("Getting Monthly sales report")
  await trackPromise (
    axios.get(process.env.REACT_APP_API_URI + `/reports/monthlysales?year=${year}`)
    .then(async (result) => {
      monthly_sales = result.data
      app.stopLoadingIndicator()
    })
    .catch(error => { app.errorLoadingIndicator(error) })
  )
  return monthly_sales
}

export const getReceivables = async (app, date) => {
  let receivables = null

  app.startLoadingIndicator("Getting Receivables report")
  await trackPromise (
    axios.get(process.env.REACT_APP_API_URI + '/reports/receivables')
    .then(async (result) => {
      receivables = result.data
      app.stopLoadingIndicator()
    })
    .catch(error => { app.errorLoadingIndicator(error) })
  )
  return receivables
}

export const getYearlySalesReport = async (app, start_year) => {
  let yearly_sales = null

  app.startLoadingIndicator("Getting Yearly sales report")
  await trackPromise (
    axios.get(process.env.REACT_APP_API_URI + `/reports/yearlysales?year=${start_year}`)
    .then(async (result) => {
      yearly_sales = result.data
      app.stopLoadingIndicator()
    })
    .catch(error => { app.errorLoadingIndicator(error) })
  )
  return yearly_sales
}

/** Similar/Identical with getProductsList() */
export const getProductsInventory = async (app, wh_id) => {
  let products_inventory = null

  app.startLoadingIndicator("Getting Products inventory")
  await trackPromise (
    axios.get(process.env.REACT_APP_API_URI + `/reports/productsinventory?warehouse_id=${wh_id}`)
    .then(async (result) => {
      products_inventory = result.data
      app.stopLoadingIndicator()
    })
    .catch(error => { app.errorLoadingIndicator(error) })
  )
  return products_inventory 
}

export { getProductsList }